// extracted by mini-css-extract-plugin
export default {"active":"Tabs_active__8adj5","inactive":"Tabs_inactive__wu7io","tab_button":"Tabs_tab_button__FwzoU"};